<div class="container" *ngIf="notasOperacao; else carregando">
    <div class="row justify-content-between">
        <div class="bn-form-group col-md-6">
            <label class="form-label"><b>Nome Agente Financeiro:</b></label>
            <input type="text" class="form-control" value="{{ nomeAgente(model.cnpjAgenteFinanceiro) }}" disabled />
        </div>

        <div class="col-auto">
            <button *ngIf="podeCadastrarNota" class="btn btn-primary" type="button" (click)="mudarRota()"
                ngbTooltip="Tela para cadastro de Nota."><i class="fa fa-file-signature">
                </i> Cadastrar nova Nota
            </button>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col">Data</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Mensagem</th>
                    <th scope="col">Responsável</th>
                    <th scope="col">Ação</th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let nota of notasOperacao">
                    <td>{{ nota.dataEnvio | date:'dd/MM/yyyy'}}</td>
                    <td>{{ nota.ativo =='S' ? 'Ativo' : 'Excluído' }}</td>
                    <td>{{ nota.mensagem.length>50 ? reduzirMensagemNota(nota) : nota.mensagem }}
                        <bn-dica *ngIf="nota.mensagem.length>50">{{nota.mensagem}}</bn-dica>
                    </td>
                    <td>{{ nota.nomeUsuarioEnvio }}</td>
                    <td>
                        <a href="javascript:void(0)" (click)="editarNota(nota)">
                            <i class="fa fa-search cursor-pointer" placement="left-top"
                                ngbTooltip="Visualizar nota"></i></a>

                        <a href="javascript:void(0)" (click)="desativacaoNota(nota)"
                            *ngIf="nota.ativo === 'S' && podeCadastrarNota">
                            <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Desativar aviso"
                                ></i></a>

                        <a href="javascript:void(0)" (click)="exportarAnexoNota(nota)" *ngIf="nota.nomeAnexo">
                            <i class=" fa fa-download cursor-pointer margin-left-5"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
      <i class="bn-loading"></i>
    </div>
  </ng-template>